import gql from 'graphql-tag'

export const CONVERSATION_SUMMARY_QUERY = gql`
  query conversationSummary($conversation: String!, $summarizationPrompt: String) {
    summary(conversation: $conversation, summarizationPrompt: $summarizationPrompt)
  }
`
